/**
 * opening act. — Merkliste (Herz), für Mode und Möbel gemeinsam.
 *
 * Ohne Login: im Browser (localStorage "oa-wishlist").
 * Mit Login: im Kundenkonto (Kunden-Metafeld oa_wish.wishlist), über den App-Proxy
 * /apps/oa/wishlist -> Cloudflare-Worker oa-api (cloudflare/oa-api-worker.js).
 *   - erster Seitenaufruf nach dem Login: Browser-Liste + Konto-Liste werden
 *     zusammengeführt und ins Konto geschrieben
 *   - danach ist das Konto die Quelle (Entfernen auf dem Handy gilt auch am Laptop)
 *   - nach dem Logout wird die Liste im Browser geleert (geteilte Geräte)
 *
 * Markup-Hooks:
 *   [data-oa-wish] data-handle data-title data-url data-img  -> Herz-Button
 *   [data-oa-wish-open]   -> Herz im Header: öffnet den Warenkorb-Drawer auf dem Tab WISHLIST
 *   [data-oa-wish-count]  -> Anzahl (Header + Tab)
 *   [data-oa-cd-tab="wl"] / [data-oa-cd-wl] -> Tab + Inhalt im Warenkorb-Drawer
 *   Link mit #wishlist    -> öffnet den Tab
 * window.oaWish = { list, has, toggle, subscribe } (wird von oa-mb.js genutzt)
 */
(function () {
  if (window.oaWish) return;
  var KEY = 'oa-wishlist';
  var ACCT = 'oa-wishlist-acct';   // "1" = Browser-Liste gehört gerade zum Konto
  var PROXY = '/apps/oa/wishlist';
  var MAX = 100;
  var loggedIn = !!window.oaCustomer;

  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} },
  };
  function clean(list) {
    var seen = {};
    return (Array.isArray(list) ? list : []).filter(function (i) {
      if (!i || !i.handle || seen[i.handle]) return false;
      seen[i.handle] = 1;
      return true;
    }).slice(0, MAX);
  }
  function load() {
    var l = [];
    try { l = JSON.parse(store.get(KEY)) || []; } catch (e) {}
    // die alte Möbel-Liste einmalig übernehmen
    try {
      var old = JSON.parse(store.get('oa-mb-wishlist')) || [];
      if (old.length) { l = l.concat(old); store.del('oa-mb-wishlist'); }
    } catch (e) {}
    return clean(l);
  }

  var wish = load();
  var subs = [];
  function has(h) { return wish.some(function (i) { return i.handle === h; }); }
  function changed() {
    store.set(KEY, JSON.stringify(wish));
    render();
    subs.forEach(function (fn) { try { fn(wish); } catch (e) {} });
  }

  // ---- Konto-Sync ----------------------------------------------------------
  var pushT = null;
  function push() {
    if (!loggedIn) return;
    clearTimeout(pushT);
    pushT = setTimeout(function () {
      fetch(PROXY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: wish }),
      }).catch(function () {});
    }, 400);
  }
  function sync() {
    if (!loggedIn) {
      // ausgeloggt: was zum Konto gehörte, bleibt nicht im Browser liegen
      if (store.get(ACCT)) { store.del(ACCT); wish = []; changed(); }
      return;
    }
    fetch(PROXY, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !Array.isArray(d.items)) return;
        var server = clean(d.items);
        if (store.get(ACCT)) {
          wish = server;                       // Konto ist die Quelle
        } else {
          wish = clean(wish.concat(server));   // erstes Mal: zusammenführen
          store.set(ACCT, '1');
          if (wish.length !== server.length) push();
        }
        changed();
      })
      .catch(function () {});
  }

  function toggle(item) {
    if (!item || !item.handle) return;
    if (has(item.handle)) wish = wish.filter(function (i) { return i.handle !== item.handle; });
    else wish = clean([{ handle: item.handle, title: item.title || '', url: item.url || '', img: item.img || '' }].concat(wish));
    changed();
    push();
  }

  // ---- Darstellung ---------------------------------------------------------
  // Die Merkliste ist ein Tab im Warenkorb-Drawer (snippets/cart-drawer.liquid):
  // gleiche Karte, gleiche Animation, gleiches Abdunkeln wie der Warenkorb.
  // Die Produktkarten rendert Shopify (sections/oa-recently-viewed.liquid,
  // Modus oawl-drawer) - sie sehen aus wie überall im Shop.
  function $$(s) { return Array.prototype.slice.call(document.querySelectorAll(s)); }
  function cd() { return document.querySelector('cart-drawer'); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function renderButtons() {
    $$('[data-oa-wish]').forEach(function (b) {
      var on = has(b.dataset.handle) ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') === on) return;
      b.setAttribute('aria-pressed', on);
      b.setAttribute('aria-label', on === 'true' ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }
  // Das Herz im Header zeichnet sich selbst: die Linie läuft einmal in ihrer
  // Richtung durch (wie mit dem Stift gezogen), danach kommt der Punkt.
  // Kein Rutschen, kein Nachfedern. Gehen: ruhiges Ausblenden.
  // Desktop (rechts bei Suche/Konto/Warenkorb): die Breite geht kurz mit auf
  // bzw. zu, damit die Symbole daneben weich zur Seite rücken. Handy (links
  // neben dem Menü, Logo fix): keine Breiten-Animation - die ließ das Herz
  // von links hereinrutschen.
  var rendered = false;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function stopHeart(b) {
    (b.__oaAnims || []).forEach(function (a) { try { a.cancel(); } catch (e) {} });
    b.__oaAnims = null;
    var path = b.querySelector('path');
    if (path) { path.style.strokeDasharray = ''; path.style.strokeDashoffset = ''; }
  }
  function showHeaderHeart(b, show) {
    var shown = !b.hidden && !b.__oaLeaving;
    if (show === shown) return;
    stopHeart(b);
    var animate = rendered && !reduce && b.animate && b.getClientRects;
    var ease = 'cubic-bezier(0.45, 0, 0.2, 1)';
    if (show) {
      b.__oaLeaving = false;
      b.hidden = false;
      if (!animate || !b.getClientRects().length) return;
      var anims = [];
      if (b.classList.contains('header__icon--wish-right')) {
        var w = b.offsetWidth, ml = getComputedStyle(b).marginLeft;
        anims.push(b.animate([{ width: '0px', marginLeft: '0px' }, { width: w + 'px', marginLeft: ml }], { duration: 260, easing: ease }));
      }
      var path = b.querySelector('path');
      if (path && path.getTotalLength) {
        var L = path.getTotalLength();
        path.style.strokeDasharray = L;
        var draw = path.animate([{ strokeDashoffset: L }, { strokeDashoffset: 0 }], { duration: 750, easing: ease, fill: 'both' });
        draw.onfinish = function () { stopHeart(b); };
        anims.push(draw);
      }
      var dot = b.querySelector('[data-oa-wish-count]');
      if (dot && !dot.hidden) {
        anims.push(dot.animate([{ opacity: 0, transform: 'scale(0)' }, { opacity: 0, transform: 'scale(0)', offset: 0.75 }, { opacity: 1, transform: 'scale(1)' }], { duration: 900, easing: 'ease-out' }));
      }
      b.__oaAnims = anims;
    } else {
      if (!animate || !b.getClientRects().length) { b.hidden = true; return; }
      b.__oaLeaving = true;
      var kf = [{ opacity: 1 }, { opacity: 0 }];
      if (b.classList.contains('header__icon--wish-right')) {
        var w2 = b.offsetWidth, ml2 = getComputedStyle(b).marginLeft;
        kf = [{ opacity: 1, width: w2 + 'px', marginLeft: ml2 }, { opacity: 0, width: w2 + 'px', marginLeft: ml2, offset: 0.5 }, { opacity: 0, width: '0px', marginLeft: '0px' }];
      }
      var out = b.animate(kf, { duration: kf.length > 2 ? 420 : 260, easing: 'ease' });
      out.onfinish = function () { b.__oaAnims = null; if (b.__oaLeaving) { b.hidden = true; b.__oaLeaving = false; } };
      b.__oaAnims = [out];
    }
  }

  function render() {
    renderButtons();
    $$('[data-oa-wish-count]').forEach(function (c) {
      if (c.textContent !== String(wish.length)) c.textContent = wish.length;
      c.hidden = wish.length === 0;
    });
    // Herz im Header nur, solange etwas gemerkt ist - kommt und geht animiert
    // (beim Seitenaufbau nicht: da steht es einfach)
    $$('[data-oa-wish-open]').forEach(function (b) { showHeaderHeart(b, wish.length > 0); });
    rendered = true;
    applyDrawer();
    if (panelWanted) queuePanel(); // the cards are fetched only once wanted
  }

  // The cards come from the server (a section render) - not on every page
  // view, only once the drawer is (about to be) opened: first tap/hover on
  // the header heart or the bag, or the drawer opening.
  var panelHTML = null, panelKey = '', panelT = null, panelWanted = false;
  // Callers that want the cards in place BEFORE the drawer shows (the dock's
  // sheet: it grew by the cards' height after rising - a jump).
  var readyCbs = [];
  function flushReady() { var c = readyCbs; readyCbs = []; c.forEach(function (fn) { try { fn(); } catch (e) {} }); }
  function whenPanel(cb) {
    wantPanel();
    if (panelHTML !== null && panelKey === handles().join(' ')) cb();
    else readyCbs.push(cb);
  }
  function wantPanel() { if (!panelWanted) { panelWanted = true; loadPanel(); } }
  ['pointerdown', 'mouseover', 'focusin'].forEach(function (t) {
    document.addEventListener(t, function (e) {
      if (!panelWanted && e.target.closest && e.target.closest('[data-oa-wish-open], [data-oa-dock-wish], #cart-icon-bubble, [data-oa-dock="cart"], .oa-dock a[href*="/cart"]')) wantPanel();
    }, { passive: true });
  });
  function handles() {
    return wish.map(function (i) { return i.handle; })
      .filter(function (h) { return /^[a-z0-9-]+$/.test(h); }).slice(0, 18);
  }
  function queuePanel() { clearTimeout(panelT); panelT = setTimeout(loadPanel, 250); }
  function loadPanel() {
    var hs = handles();
    var key = hs.join(' ');
    if (!hs.length) { panelHTML = null; panelKey = ''; applyDrawer(); return; }
    if (key === panelKey) return;
    panelKey = key;
    var url = root() + 'search?type=product&q=' + encodeURIComponent('oawl-drawer ' + key) + '&section_id=oa-recently-viewed';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (key !== panelKey) return;
        var doc = new DOMParser().parseFromString(html || '', 'text/html');
        var sec = doc.querySelector('.shopify-section') || doc.body;
        panelHTML = sec && sec.querySelector('[data-oa-rv-count]') ? sec.innerHTML : '';
        applyDrawer();
        flushReady();
      })
      .catch(function () { if (key === panelKey) panelKey = ''; flushReady(); });
  }

  function note() {
    if (loggedIn || !window.oaLoginUrl) return '';
    return '<p class="oa-cd-wl__note"><a href="' + window.oaLoginUrl + '">Log in</a> to keep your wishlist on every device.</p>';
  }

  function applyDrawer() {
    var c = cd();
    if (!c) return;
    if (c.__oaWlClosing) return; // folding away after the last favourite went - leave it as it is
    var any = wish.length > 0;
    // Last favourite removed while the wishlist is on screen: close the
    // drawer instead of falling back to VIEWED. The tab stays on until the
    // panel has folded away, then everything is tidied up as usual.
    if (!any && c.classList.contains('oa-wl-on') && c.classList.contains('active')) {
      c.__oaWlClosing = true;
      c.close();
      setTimeout(function () { c.__oaWlClosing = false; applyDrawer(); }, 1000); // fold-up incl. its easing tail
      return;
    }
    c.classList.toggle('oa-wl-has', any);
    if (!any) c.classList.remove('oa-wl-on');
    var tab = c.querySelector('[data-oa-cd-tab="wl"]');
    var sep = c.querySelector('.oa-cd-tabs__sep--wl');
    if (tab && tab.hidden === any) tab.hidden = !any;
    if (sep && sep.hidden === any) sep.hidden = !any;
    var panel = c.querySelector('[data-oa-cd-wl]');
    if (panel && panelHTML !== null && panel.getAttribute('data-k') !== panelKey) {
      panel.innerHTML = panelHTML + note();
      panel.setAttribute('data-k', panelKey);
      renderButtons();
    }
    var on = c.classList.contains('oa-wl-on');
    if (!on) {
      // die anderen Tabs setzen ihre Skripte (oa-recently-viewed.js / oa-cart-split.js)
      if (window.oaRvApplyDrawer) window.oaRvApplyDrawer();
      else if (window.oaCartSplit) window.oaCartSplit.apply();
    }
    c.querySelectorAll('[data-oa-cd-tab]').forEach(function (t) {
      var k = t.getAttribute('data-oa-cd-tab');
      if (!on && k !== 'wl') return;
      var act = on && k === 'wl';
      t.classList.toggle('is-active', act);
      t.setAttribute('aria-selected', act ? 'true' : 'false');
    });
  }

  function showTab(c) {
    c.classList.remove('oa-rv-on');
    c.classList.add('oa-wl-on');
    applyDrawer();
    panelWanted = true;
    loadPanel();
  }
  // Übers Herz geöffnet: nur WISHLIST | VIEWED - kein CART-Tab, damit es nicht
  // wie der Warenkorb aussieht (component-cart-drawer.css: .oa-wl-mode)
  function openWish(trigger) {
    var c = cd();
    if (!c || !wish.length) return;
    c.classList.add('oa-wl-mode');
    if (c.classList.contains('active')) {
      if (c.classList.contains('oa-wl-on')) { c.close(); return; } // zweiter Klick schließt
      showTab(c);
      return;
    }
    c.__oaWl = true;
    showTab(c);
    if (typeof c.open === 'function') c.open(trigger);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-oa-wish]');
    if (b) {
      e.preventDefault();
      e.stopPropagation();
      var item = b.closest('.oa-cd-wl .grid__item');
      toggle({ handle: b.dataset.handle, title: b.dataset.title, url: b.dataset.url, img: b.dataset.img });
      if (item && !has(b.dataset.handle)) { if (wish.length) item.remove(); } // last one: drawer closes with the card still in
      else if (b.animate && has(b.dataset.handle)) b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 300, easing: 'ease' });
      return;
    }
    var rm = e.target.closest('[data-oa-wl-rm]');
    if (rm) {
      e.preventDefault();
      var li = rm.closest('.grid__item');
      toggle({ handle: rm.getAttribute('data-oa-wl-rm') });
      if (li && wish.length) li.remove();
      return;
    }
    // ADD TO CART unter einer Karte der Merkliste: drei Punkte, Haken, dann Warenkorb
    var add = e.target.closest('.oa-cd-wl [data-oa-rv-add]');
    if (add) {
      e.preventDefault();
      e.stopPropagation(); // nicht zusätzlich oa-recently-viewed.js
      var c0 = cd();
      if (!c0 || add.classList.contains('oa-atc-busy') || add.classList.contains('is-added')) return;
      add.classList.add('oa-atc-busy');
      var fd = new FormData();
      fd.append('id', add.getAttribute('data-oa-rv-add'));
      fd.append('quantity', '1');
      if (typeof c0.getSectionsToRender === 'function') {
        fd.append('sections', c0.getSectionsToRender().map(function (x) { return x.id; }));
        fd.append('sections_url', location.pathname);
      }
      fetch((window.routes && window.routes.cart_add_url) || root() + 'cart/add', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd,
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          add.classList.remove('oa-atc-busy');
          if (res.status) { add.textContent = res.description || 'Not available'; add.disabled = true; return; }
          // Punkte -> Haken "Added" -> erst dann der Warenkorb
          add.classList.add('is-added');
          setTimeout(function () {
            if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'oa-wishlist', cartData: res });
            if (typeof c0.renderContents === 'function') c0.renderContents(res);
          }, 650);
        })
        .catch(function () { add.classList.remove('oa-atc-busy'); });
      return;
    }
    var o = e.target.closest('[data-oa-wish-open]');
    if (o) { e.preventDefault(); openWish(o); return; }
    var t = e.target.closest('[data-oa-cd-tab="wl"]');
    if (t) { var c = t.closest('cart-drawer'); if (c) showTab(c); }
  }, true);
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest && e.target.closest('[data-oa-cd-tab="wl"]')) {
      e.preventDefault();
      var c = cd();
      if (c) showTab(c);
    }
  });

  // Warenkorb-Symbol öffnet immer den Warenkorb; in den Warenkorb legen zeigt ihn auch
  if (window.customElements) {
    customElements.whenDefined('cart-drawer').then(function () {
      var C = customElements.get('cart-drawer');
      if (!C || C.prototype.__oaWl) return;
      C.prototype.__oaWl = true;
      var open = C.prototype.open;
      C.prototype.open = function () {
        if (!this.__oaWl && !this.classList.contains('active')) { this.__oaWlClosing = false; this.classList.remove('oa-wl-on', 'oa-wl-mode'); applyDrawer(); }
        this.__oaWl = false;
        wantPanel();
        return open.apply(this, arguments);
      };
      var renderContents = C.prototype.renderContents;
      C.prototype.renderContents = function () {
        this.classList.remove('oa-wl-on', 'oa-wl-mode');
        // renderContents only follows an add-to-cart, so the cart is no longer
        // empty. Dawn's product-form.js removes .is-empty itself; the Wishlist and
        // Viewed tabs did not -> on a previously empty cart the drawer read "Cart 1"
        // but kept hiding the items (.is-empty) until the next page load.
        this.classList.remove('is-empty');
        return renderContents.apply(this, arguments);
      };
    });
  }

  // Der Drawer ersetzt sein HTML nach jeder Warenkorb-Änderung: Tab + Liste zurücksetzen
  function watchDrawer() {
    var c = cd();
    if (!c || c.__oaWlWatch) return;
    c.__oaWlWatch = true;
    var t = null;
    new MutationObserver(function (muts) {
      var rerender = muts.some(function (m) {
        return m.target.id === 'CartDrawer' || (m.target.classList && m.target.classList.contains('drawer__inner'));
      });
      if (!rerender) return;
      clearTimeout(t);
      t = setTimeout(function () {
        render(); // die frisch gerenderte (leere) Liste wird aus dem Zwischenspeicher befüllt
      }, 60);
    }).observe(c, { childList: true, subtree: true });
  }

  // Karten, die später nachgeladen werden (Show more, Suche), bekommen den Zustand mit
  if ('MutationObserver' in window) {
    var mT = null;
    new MutationObserver(function () { clearTimeout(mT); mT = setTimeout(renderButtons, 120); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  window.oaWish = {
    list: function () { return wish.slice(); },
    has: has,
    toggle: toggle,
    open: function () { openWish(null); },
    whenPanel: whenPanel,
    subscribe: function (fn) { subs.push(fn); },
  };

  // ---- Zähler im Header rollen wie ein Zählwerk ----------------------------
  // Ändert sich die Zahl am Herz oder am Warenkorb, wird sie nicht einfach
  // ersetzt: die alte rollt nach oben weg, die neue kommt von unten (beim
  // Verringern umgekehrt). Der Text selbst bleibt unangetastet (andere
  // Skripte lesen ihn) - die alte Zahl ist eine kurzlebige Kopie daneben.
  (function () {
    if (reduce) return;
    var COUNTS = [
      { key: 'cart-fashion', sel: '#cart-icon-bubble [data-oa-bubble="fashion"] .cart-count-bubble span[aria-hidden]' },
      { key: 'cart-furniture', sel: '#cart-icon-bubble [data-oa-bubble="furniture"] .cart-count-bubble span[aria-hidden]' },
      // the heart shows only a dot (oa-wishlist.css) - nothing to roll there
    ];
    function read(c) {
      var el = document.querySelector(c.sel);
      var n = el && !el.hidden ? parseInt(el.textContent, 10) : 0;
      return { el: el, n: isNaN(n) ? 0 : n };
    }
    var last = {};
    COUNTS.forEach(function (c) { last[c.key] = read(c).n; });
    function roll(el, from, up) {
      if (!el.animate || !el.getClientRects().length) return;
      var D = 380, E = 'cubic-bezier(0.2, 0.8, 0.3, 1)', dist = '0.9em';
      if (from > 0 && el.parentNode) {
        var g = el.cloneNode(false);
        ['data-oa-wish-count', 'aria-hidden', 'hidden'].forEach(function (a) { g.removeAttribute(a); });
        g.classList.add('oa-roll-ghost');
        g.textContent = from;
        g.setAttribute('aria-hidden', 'true');
        // the cart's number sits in its bubble - the copy goes on top of it
        if (el.tagName === 'SPAN') { g.style.position = 'absolute'; g.style.left = el.offsetLeft + 'px'; g.style.top = el.offsetTop + 'px'; }
        el.parentNode.insertBefore(g, el.nextSibling);
        g.animate([{ transform: 'none', opacity: 1 }, { transform: 'translateY(' + (up ? '-' : '') + dist + ')', opacity: 0 }],
          { duration: D, easing: E, fill: 'forwards' }).onfinish = function () { g.remove(); };
      }
      el.animate([{ transform: 'translateY(' + (up ? '' : '-') + dist + ')', opacity: 0 }, { transform: 'none', opacity: 1 }],
        { duration: D, easing: E });
    }
    var t = 0;
    function check() {
      t = 0;
      COUNTS.forEach(function (c) {
        var r = read(c);
        var was = last[c.key];
        last[c.key] = r.n;
        if (r.el && r.n !== was && r.n > 0) roll(r.el, was, r.n > was);
      });
    }
    function watch() {
      var hdr = document.querySelector('.section-header') || document.querySelector('header');
      if (!hdr || !window.MutationObserver) return;
      new MutationObserver(function (muts) {
        // our own copies coming and going are not a change
        if (muts.every(function (m) {
          var n = [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes));
          return n.length && n.every(function (x) { return x.classList && x.classList.contains('oa-roll-ghost'); });
        })) return;
        if (!t) t = requestAnimationFrame(check);
      }).observe(hdr, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
    else watch();
  })();

  // Link "…/#wishlist" (z. B. aus dem Menü im Kundenkonto) öffnet die Merkliste
  function fromHash() {
    if (location.hash !== '#wishlist') return;
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
    openWish(null);
  }
  window.addEventListener('hashchange', fromHash);
  // Phones (dock): fetch the cards in the background once the page is loaded,
  // so the dock's heart opens a drawer that is already filled.
  window.addEventListener('load', function () {
    if (!wish.length || !document.querySelector('.oa-dock') || !window.matchMedia('(max-width: 989px)').matches) return;
    setTimeout(wantPanel, 1200);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watchDrawer(); render(); sync(); fromHash(); });
  else { watchDrawer(); render(); sync(); fromHash(); }
})();
